
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useVendorStore from "../../HomePage/useVendorStore";
import { STATUS_BEGIN, STATUS_DONE, STATUS_FAIL } from "utils/constants/others";
import WhiltelistedFileTypes from "../../Common/Logout";

export default function useDDPodFormLogic() {
    const getPurchaseOrders = useVendorStore((state) => state.getPurchaseOrders);
    const getPurchaseOrderStatus = useVendorStore(
        (state) => state.getPurchaseOrderStatus
    );
    const validatePodOtp = useVendorStore((state) => state.validatePodOtp);
    const validatePodOtpStatus = useVendorStore(
        (state) => state.validatePodOtpStatus
    );
    const purchaseOrders = useVendorStore((state) => state.purchaseOrders);
    const uploadPodStatus = useVendorStore((state) => state.uploadPodStatus);
    const getPresignedUrl = useVendorStore((state) => state.getPresignedUrl);
    const getPresignedUrlStatus = useVendorStore(
        (state) => state.getPresignedUrlStatus
    );
    const podPresignedUrl = useVendorStore((state) => state.podPresignedUrl);
    const podFilePath = useVendorStore((state) => state.podFilePath);
    const uploadPod = useVendorStore((state) => state.uploadPod);
    const getBuyerOrderPodDetails = useVendorStore((state) => state.getBuyerOrderPodDetails);
    const getBuyerOrderPodDetailsStatus = useVendorStore((state) => state.getBuyerOrderPodDetailsStatus);
    const buyerOrdersLinkedtoPO = useVendorStore((state) => state.buyerOrdersLinkedtoPO);

    const [po, setPo] = useState("");
    const [items, setItems] = useState("");
    let { source, purchaseOrderId, orderId, goTo } = useParams();
    const [showLoader, setShowLoader] = useState(false);
    const [tonnage, setTonnage] = useState(0);
    const [errorMsg, setErrorMsg] = useState(false);
    const [otpPage, setOtpPage] = useState(false);
    const [otp, setOtp] = useState("");
    const [showError, setShowError] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const navigate = useNavigate();
    const [podPages, setPodPages] = useState([]);
    const [imageArray, setImageArray] = useState(new Array(5).fill(null));
    const [previewImage, setPreviewImage] = useState([]);
    const [numberOfPodPages, setNumberOfPodPages] = useState(0);
    const [fileTypeErr, setFileTypeErr] = useState(false);
    const [bo, setBo] = useState("");
    const [errorText, setErrorText] = useState("");

    useEffect(() => {
        getPurchaseOrders({
            is_item_required: true,
            purchase_order_id: purchaseOrderId,
        }, true);
        if (goTo && goTo === "otp") {
            setOtpPage(true);
        }
    }, []);

    useEffect(() => {
        if (getPurchaseOrderStatus === STATUS_DONE && purchaseOrders) {
            setPo(purchaseOrders[0]);
        }
        getBuyerOrderPodDetails({
            purchase_order_id: purchaseOrderId,
        });
    }, [purchaseOrders]);

    useEffect(() => {
        if (po.purchase_order_items) {
            setItems(po.purchase_order_items);
        }
    }, [po]);

    useEffect(() => {
        if (getBuyerOrderPodDetailsStatus === STATUS_DONE) {
            for (let i = 0; i < buyerOrdersLinkedtoPO.length; i++) {
                if (buyerOrdersLinkedtoPO[i].pod_order_id === parseInt(orderId)) {
                    setBo(buyerOrdersLinkedtoPO[i]);
                }
            }
        }
    }, [getBuyerOrderPodDetailsStatus]);

    useEffect(() => {
        if (getPurchaseOrderStatus === STATUS_BEGIN) {
            setShowLoader(true);
        }
        if (getPurchaseOrderStatus === STATUS_DONE) {
            setShowLoader(false);
        }
    }, [getPurchaseOrderStatus]);

    useEffect(() => {
        if (bo?.is_pod_validated || bo?.number_of_pod_pages === 0) {
            setOtpPage(true);
        } else if (bo?.number_of_pod_pages) {
            setNumberOfPodPages(bo?.number_of_pod_pages);
        }
    }, [bo]);

    useEffect(() => {
        if (numberOfPodPages > 0) {
            setImageArray(new Array(numberOfPodPages).fill(null));
        }
    }, [numberOfPodPages]);

    useEffect(() => {
        calculateTonnage();
    }, [items]);

    useEffect(() => {
        if (uploadPodStatus === STATUS_DONE) {
            setShowLoader(false);
        }
    }, [uploadPodStatus]);

    const calculateTonnage = () => {
        let total = 0;
        for (const item of items) {
            total = total + item.quantity_ordered * item.weight_per_packet;
        }
        setTonnage(total);
    };

    const navigateToOtpPage = () => {
        if (previewImage.length < numberOfPodPages || errorMsg) {
            setErrorMsg(true);
        } else {
            setOtpPage(true);
        }
    };

    const makeValidateOtp = () => {
        validatePodOtp({
            order_id: parseInt(orderId),
            otp: otp,
            validate_all_pod_pages_uploaded: true,
            purchase_order_id: parseInt(purchaseOrderId),
        });
    };

    const goToDDList = () => {
        navigate("/ddPo/all");
    };

    const closeConfirmation = () => {
        setOpenConfirmation(false);
        navigate("/ddPo/all");
        window.location.reload();
    };

    const uploadFileToS3 = (file, preSignedUrl) => {
        return fetch(preSignedUrl, {
            method: "PUT",
            body: file,
            headers: {
                "Content-Type": file?.type,
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response;
                } else {
                    setErrorMsg(true);
                }
            })
            .catch((err) => {
                setErrorMsg(true);
            });
    };

    useEffect(() => {
        if (validatePodOtpStatus?.status === STATUS_DONE) {
            setOpenConfirmation(true);
        } else if (validatePodOtpStatus?.status === STATUS_FAIL) {
            setShowError(true);
            setErrorText(validatePodOtpStatus?.message || "Wrong OTP Entered");
        }
    }, [validatePodOtpStatus]);

    useEffect(() => {
        if (podPages?.length > 0 && orderId > 0) {
            getPresignedUrl({
                order_id: parseInt(orderId),
            });
        }
    }, [podPages]);

    useEffect(() => {
        if (getPresignedUrlStatus === STATUS_DONE && podPages?.length > 0) {
            let fileArr = [podFilePath];
            uploadFileToS3(podPages[podPages?.length - 1], podPresignedUrl).then((data) => {
                let formData = new FormData();
                formData.append("orderId", parseInt(orderId));
                formData.append("imageType", "invoice");
                formData.append("file_path_data", JSON.stringify(fileArr));
                uploadPod(formData);
            });
        }
    }, [getPresignedUrlStatus]);

    useEffect(() => {
        if (uploadPodStatus === STATUS_FAIL) {
            setPreviewImage([]);
            setErrorMsg(true);
            setShowLoader(false);
        }
    }, [uploadPodStatus]);

    const handleImageInputChange = (e) => {
        const file = e.target.files[0];
        if (file && WhiltelistedFileTypes.WhiltelistedFileTypes(file.type)) {
            setErrorMsg(false);
            setShowLoader(true);
            const reader = new FileReader();
            setPodPages([...podPages, file]);
            reader.onload = (e) => {
                const imageData = e.target.result;
                setPreviewImage([...previewImage, imageData]);
            };
            reader.readAsDataURL(file);
        } else {
            setFileTypeErr(true);
        }
    };

    return {
        po,
        items,
        showLoader,
        tonnage,
        errorMsg,
        otpPage,
        otp,
        setOtp,
        showError,
        openConfirmation,
        podPages,
        imageArray,
        previewImage,
        numberOfPodPages,
        fileTypeErr,
        bo,
        errorText,
        navigateToOtpPage,
        makeValidateOtp,
        closeConfirmation,
        handleImageInputChange,
        goToDDList,
    };
}
